import { useMetrics } from '@cognite/metrics';
import type { Metrics } from '@fusion/telemetry';
import { useMetrics as useOtelMetrics } from '@fusion/telemetry';
import { getConnectionDownlinkSpeedInMbps } from '@infield/utils/get-connection-downlink-speed';
import { createContext } from 'react';

/**
 * The context to inject dependency to facilitate testing
 * and storybooking without having to make complex mocks
 */

/**
 * Type narrowing to only "subscribe" to the
 * properties that we need from the different dependencies
 */
export interface UseInFieldMetricsContextInterface {
  useMetrics: (
    ...args: Parameters<typeof useMetrics>
  ) => Pick<ReturnType<typeof useMetrics>, 'track'>;
  useOtelMetrics: (...args: Parameters<typeof useOtelMetrics>) => {
    metrics: Pick<Metrics, 'createHistogram'>;
  };
  getConnectionDownlinkSpeedInMbps: typeof getConnectionDownlinkSpeedInMbps;
}

export const defaultValue: UseInFieldMetricsContextInterface = {
  useMetrics,
  useOtelMetrics,
  getConnectionDownlinkSpeedInMbps,
};

export const UseInFieldMetricsContext =
  createContext<UseInFieldMetricsContextInterface>(defaultValue);
